import { render, staticRenderFns } from "./link-account-eamil.vue?vue&type=template&id=ceed2d70&scoped=true&"
import script from "./link-account-eamil.vue?vue&type=script&lang=js&"
export * from "./link-account-eamil.vue?vue&type=script&lang=js&"
import style0 from "./link-account-eamil.vue?vue&type=style&index=0&id=ceed2d70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceed2d70",
  null
  
)

export default component.exports